import axiosAutoCheck from "global/helpers/axiosAutoCheckIn";
import { PRESENTE, PRESENTE_FAIL, PRESENTE_SUCCESS } from "../ActionTypes";

export const wsPostAsignarPresente = (idTurno,sectorTurno,nextStep) => (dispatch) => {
  dispatch({ type: PRESENTE });

  axiosAutoCheck().then((respuesta) => {
    respuesta
      .post(`/asignarPresente/${idTurno}/${sectorTurno}`)
      .then((resp) => {
        dispatch({ type: PRESENTE_SUCCESS, payload: resp.data });
        if (nextStep) nextStep(true);
      })
      .catch((err) => {
        dispatch({ type: PRESENTE_FAIL, payload: err.response.data });
        if (nextStep) nextStep(false);
      });
  });
};
